//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "CVC",
  data() {
    return {
      form: {
        height: "",
      },
      hasScore: false,
      disabled: false,
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            if (form[key] == "---") {
              flag = false;
            } else {
              form[key] = Number(form[key]);
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "--";
      } else {
        let result1 = ((form.height / 10).toFixed(2)).toString()
        let result2 = ((form.height / 10 - 2).toFixed(2)).toString()
        let result3 = ((form.height / 10 + 4).toFixed(2)).toString()
        let result4 = ((form.height / 10 + 2).toFixed(2)).toString()
        self.hasScore = true;
        return {
          result1,
          result2,
          result3,
          result4
        };
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/CVC.vue